import React, { FC } from 'react'
import { Shared } from 'ui/shared'
import Grid from '@mui/material/Grid'
import { Form } from 'utils/helpers/form'
import { useTranslation } from 'react-i18next'
import { I18nModal } from 'utils/i18n/i18nModal'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { useForm } from 'react-hook-form'
import { Actions_CurrentUser } from 'redux/modules/currentUser/Actions'
import { Actions_Modals } from 'redux/modules/modals/Actions'

interface IForm {
  parkingId: number
}

export const ChangeRentFinishParking: FC = () => {
  const { t } = useTranslation(I18nModal.changeRentFinishParking)
  const dispatch = useDispatch()

  const { isCompleteRentInProgress, parkings, rentId, userRent } = useSelector(
    ({ parkings, currentUser, rents }: TState) => ({
      isCompleteRentInProgress: currentUser.isLoading,
      parkings: parkings.parkingsReturnForChange || [],
      rentId: currentUser.data?.rentId,
      userRent: rents.userRent,
    }),
    shallowEqual,
  )

  const { handleSubmit, errors, control } = useForm<IForm>()

  const onSubmit = (formData: IForm) => {
    if (rentId) {
      const data = {
        rentId,
        parkingId: formData.parkingId,
      }
      dispatch(Actions_CurrentUser.saga.changeRentFinishParking(data))
    }
  }

  const closeModal = () => {
    dispatch(Actions_Modals.store.hideModal())
  }

  const parkingsOptions = parkings
    .filter((item) => item.parkingInfo.isVirtual === userRent?.finishParking.isVirtual)
    .map(({ parkingInfo }) => ({
      id: parkingInfo.id,
      label: parkingInfo.parkingCode,
      value: parkingInfo.id,
    }))

  return (
    <Shared.Card style={{ width: 375 }}>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Shared.CardTitle title={t('title')} />
          </Grid>

          <Grid item xs={12}>
            <Shared.AutocompleteForForm
              name="parkingId"
              label={t('parking')}
              options={parkingsOptions}
              control={control}
              rules={Form.required}
              error={errors.parkingId?.message}
            />
          </Grid>

          <Grid item xs={12}>
            <Shared.Button
              style={{ margin: '2em 0 0.875em 0' }}
              color={'secondary'}
              title={t('cancel')}
              onClick={closeModal}
              disabled={isCompleteRentInProgress}
            />
            <Shared.Button title={t('submit')} type={'submit'} disabled={isCompleteRentInProgress} />
          </Grid>

          {/* {(isLoadingStations || isCompleteRentInProgress) && <Shared.Preloader mask />} */}
        </Grid>
      </form>
    </Shared.Card>
  )
}
